import React from "react"
import {
    componentStyles,
    Modal,
    MultiMediaDisplay,
    MediaDisplayType,
} from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"
import type { OutfitterLodgingFieldsFragment } from "~graphql/generated/graphql"
import { Text } from "~components/shared/todo-lib-react-components/text"
import { useTabletMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"
import { formatCapacity } from "~utils/lodging-helpers"
import Location from "~components/shared/location"

interface Props {
    readonly isOpen: boolean
    readonly onClose: () => void
    readonly lodging: OutfitterLodgingFieldsFragment
}

export default function LodgeItemModal({ isOpen, onClose, lodging }: Props) {
    const styles = useStyles()
    const { isLargerThanTablet } = useTabletMediaQueries()

    const mediaDisplayType = isLargerThanTablet
        ? MediaDisplayType.GRID
        : MediaDisplayType.CAROUSEL
    const images = lodging.images ?? []
    const hasImages = Boolean(images.length)

    return (
        <Modal
            style={styles.root}
            isOpen={isOpen}
            onClose={onClose}
            title={lodging.type_name}
            shouldAddPadding
        >
            {hasImages && (
                <MultiMediaDisplay type={mediaDisplayType} images={images} />
            )}
            <Text style={styles.name}>{lodging.name}</Text>
            <Text>{lodging.description || COPY.LODGINGS.NO_DESCRIPTION}</Text>
            <Text>{formatCapacity(lodging)}</Text>
            <Location location={lodging.location} />
        </Modal>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            gap: 5,
        },
        image: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
        },
        imageAspectRatio: {
            width: "24px",
            marginRight: "4px",
            display: "inline-block",
        },
        name: {
            fontWeight: 700,
        },
    })
}
